// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { MerchantLimitFilterTypes, merchantLimitFilterInitialValue, merchantLimitFilterSchemaType } from './_formTypes';
import {
    PagingResponse,
    useGetMerchantList,
    useGetMerchantLimits,
    useGetMerchantsWithParentMerchant,
    useAuthorization,
    useUpdateMerchantLimit,
    GetMerchantLimitRequest
} from "../../../hooks";
import {
    FormControl,
    Link,
    Box,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
    Checkbox,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button as MaterialButton,
    Grid,
    CardHeader,
    colors,
    Divider,
} from "@mui/material";
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import {
    GridColDef,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
    GridExpandMoreIcon,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
    DateTimePickerControl,
    SelectControl,
    InputControl,
    Table,
    DeleteConfirmModal,
    NumericFormatInputControl,
    createBooleanOperator,
    MerchantLimitHistoryMaster,
    ReportRequestListModal
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';

import StatCard from "./components/StatCard";

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
    timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTimeline(timeLineData) {
    return (
        <Timeline
            sx={{
                [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.2,
                },
                height: '100%'
            }}
        >
            {timeLineData && timeLineData.map((item) => {

                return <TimelineItem>
                    <TimelineOppositeContent color="textSecondary" variant="h5">
                        {dayjs(item.createDate).format('HH:mm  DD.MM.YYYY')}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineDot />
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                        <Typography variant="h5" component="span">
                            {item.createUserName ?? "BACKOFFICE"}
                        </Typography>
                        <Typography variant="subtitle2">{item.property} değerini <strong>{formatDecimal(item.oldValue)}</strong>'den <strong>{formatDecimal(item.newValue)}</strong> olarak güncelledi</Typography>
                    </TimelineContent>
                </TimelineItem>

            })}
        </Timeline>
    );
}

const formatDecimal = (value) => {
    let formattedValue = value?.toString();
    if (formattedValue?.includes(',')) {
        formattedValue = formattedValue.replace(',', '.');
    }
    return `${parseFloat(formattedValue ?? '0.00').toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })} TL`;
};

export const MerchantLimitFilter = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [userInfo] = useUserInfo();
    const setSnackbar = useSetSnackBar();
    const [queryOptions, setQueryOptions] = React.useState({});
    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const [showTable, setShowTable] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 1,
        pageSize: 25,
    });
    const [tableselectedRow, setTableSelectedRow] = useState({} as any);
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant(null);
    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantLimitFilterTypes>({
            resolver: zodResolver(merchantLimitFilterSchemaType),
            defaultValues: merchantLimitFilterInitialValue,
        });

    const {
        mutate: GetMerchantLimits,
        isLoading: isGetMerchantLimitsLoading
    } = useGetMerchantLimits();

    const { mutate: UpdateMerchantLimit, isLoading: isUpdateMerchantLoading } = useUpdateMerchantLimit();

    const [formValues, setFormValues] = useState<GetPaymentAndTransactionRequest | null>(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const merchantList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data]);

    //#region : Table Content

    useEffect(() => {
        const savedFilter = localStorage.getItem("merchantFilterListKey");
        if (savedFilter) {
            setQueryOptions(JSON.parse(savedFilter));
        }
    }, []);

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
        setTableData(undefined);
        return;
    }

    const getQueryParams = (filters) => {
        const queryParams = {};

        for (let key in filters) {
            let value = filters[key];
            if (value === "false") {
                queryParams[key] = false;
            } else if (key === 'filterMerchantId') {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams['filterSubMerchantId'] = Number(value);
                }
            } else if (value !== null && value !== undefined && value.toString().length > 0) {
                if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
                    queryParams[key] = Number(parseFloat(value).toFixed(2));
                } else {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const convertTableFiltersToRequestFilter = (tableFilters) => {

        let convertedFilters = [];

        tableFilters.items.map((item) => {

            var findColumn = columns.find(x => x.field == item.field);

            convertedFilters.push({
                field: item.field,
                values: [item.value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const [dynamicFilters, setDynamicFilter] = useState([]);

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            localStorage.removeItem('merchantFilterListKey')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key, value) => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }


        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // Eğer queryParams bir önceki ile aynıysa işlem yapma
        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
            localStorage.setItem('merchantFilterListKey', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

    const deleteRow = React.useCallback(
        (transaction: any) => () => {
            setTableSelectedRow(transaction);
        },
        []
    );

    const { showDelete, showUpdate } = useAuthorization();
    const columns: GridColDef[] = useMemo(() => {
        return [
            {
                field: "merchantName", headerName: "Üye İşyeri Adı", width: 180,
                renderCell: (params) => params.value ? params.value.toString() : "", columnType: RequestFilterValueTypeEnums.STRING
            },
            {
                field: "merchantId", headerName: "Üye İşyeri Numarası", width: 180,
                renderCell: (params) => params.value ? params.value.toString() : "", columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: "limit",
                headerName: "Ana Limit",
                type: 'decimal',
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: "extraLimit",
                headerName: "Extra Limit",
                type: 'decimal',
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: "totalLimit",
                headerName: "Tanımlanan Limit",
                type: 'decimal',
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: "usedLimit",
                headerName: "Kullanlan Limit",
                type: 'decimal',
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params.value} TL`;
                },
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: "remainingLimit",
                headerName: "Kalan Limit",
                type: 'decimal',
                width: 200,
                valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${params?.value ?? 0} TL`;
                },
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            { field: "limitExcessCount", headerName: "Limit Aşımı", width: 150, valueFormatter: (params) => { return params.value ?? '-' }, columnType: RequestFilterValueTypeEnums.NUMBER },
            {
                field: "startDate", headerName: "Başlangıç T.", width: 200,
                columnType: RequestFilterValueTypeEnums.DATE,
                renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                }
            },
            {
                field: "finishDate", headerName: "Bitiş T.", width: 200,
                columnType: RequestFilterValueTypeEnums.DATE,
                renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                }
            }
        ];
    }, [deleteRow, showDelete]);

    //#endregion

    const hasLoading = isGetMerchantLimitsLoading || isMerchantListLoading;

    const onSubmit = (data: MerchantLimitFilterTypes) => {
        const req: GetPaymentAndTransactionRequest = {
            size: paginationModel.pageSize,
            page: paginationModel.page == 0 ? 1 : paginationModel.page,
            orderBy: "CreateDate",
            filters: [],
            merchantId: 0,
            isHistory: false,
        };

        setFormValues(req);
        setIsSubmitted(true);
    }

    useEffect(() => {
        if (!isSubmitted || !formValues) {
            return;
        }

        const requestPayload = {
            ...formValues,
            ...getQueryParams(queryOptions),
            size: paginationModel.pageSize,
            page: paginationModel.page,
        };

        if (requestPayload.filters) {
            requestPayload.filters = [
                ...requestPayload.filters,
                ...dynamicFilters
            ]
        }

        // requestPayload.filters = dynamicFilterList;

        if (queryOptions?.field && queryOptions?.value !== undefined) {
            requestPayload[queryOptions.field] = queryOptions.value;
        }

        GetMerchantLimits(requestPayload, {
            onSuccess: (data) => {
                if (data.isSuccess) {

                    data.data.result.map((item) => { item.isRowExpanable = true });

                    setTableData(data.data);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setTableData(data.data);
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }, [formValues, isSubmitted, queryOptions, paginationModel]);

    const [tabValue, setTabValue] = React.useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {

        if (newValue == 1) {
            onSubmit({});
        }

        setTabValue(newValue);
    };

    const [currentMerchantLimitData, setCurrentMerchantLimitData] = useState(null);

    const handleMerchantChange = (merchantId) => {

        let req = {
            merchantId: merchantId,
            isHistory: false,
            page: 1,
            size: 25
        };

        GetMerchantLimits(req, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setCurrentMerchantLimitData(data.data?.result[0]);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setCurrentMerchantLimitData(data.data);
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            }
        })

    }

    const [currentMerchantTableData, setCurrentMerchantTableData] = useState({
        isActive: false,
        data: []
    })

    useEffect(() => {

        if (currentMerchantLimitData) {
            const request: GetMerchantLimitRequest = {
                merchantId: currentMerchantLimitData?.merchantId,
                isHistory: true
            }

            GetMerchantLimits(request, {
                onSuccess: (data) => {
                    if (data.isSuccess) {

                        setCurrentMerchantTableData({
                            isActive: true,
                            data: data.data
                        });
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message,
                        });
                    } else {
                        setCurrentMerchantTableData({
                            isActive: false,
                            data: []
                        });
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                }
            })
        }

    }, [currentMerchantLimitData])

    const handleLimitUpdate = () => {


        let requestPayload = {
            newLimit: parseFloat(getValues('newLimit')),
            merchantId: getValues('merchantId'),
            merchantLimitId: currentMerchantLimitData?.id
        };

        UpdateMerchantLimit(requestPayload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                    handleMerchantChange(requestPayload.merchantId);
                    setValue("newLimit", 0);
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }

    return (<>
        {hasLoading && <Loading />}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example" centered={true} sx={{ flex: 1, width: '100%' }}>
                <Tab label="Üye İşyeri" {...a11yProps(0)} sx={{ width: '100%' }} />
                <Tab label="Tüm Üye İşyerleri" {...a11yProps(1)} sx={{ width: '100%' }} />
            </Tabs>
        </Box>
        <CustomTabPanel value={tabValue} index={0}>
            <Stack spacing={2}>
                <Stack
                    spacing={3}
                    direction={isDesktop ? "row" : "column"}
                    width={isDesktop ? "100%" : "auto"}
                >
                    <FormControl sx={{ flex: 1 }}>
                        {merchantList && (
                            <Controller
                                name="merchantId"
                                control={control}
                                defaultValue={0}
                                render={({ field: { onChange, value } }) => {
                                    const selectedMerchant = merchantList.find(
                                        (option) => option.value === value
                                    );

                                    return (
                                        <Autocomplete
                                            id="merchantId"
                                            options={merchantList}
                                            getOptionSelected={(option, value) =>
                                                option.value === value
                                            }
                                            getOptionLabel={(option) => option.label}
                                            value={selectedMerchant || null}
                                            onChange={(_, newValue) => {
                                                onChange(newValue ? newValue.value : "");

                                                if (newValue) {
                                                    handleMerchantChange(newValue.value)
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="İşyeri" />
                                            )}
                                        />
                                    );
                                }}
                            />
                        )}
                    </FormControl>
                </Stack>
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    width={isDesktop ? "100%" : "auto"}
                >

                </Stack>
            </Stack>
            <Stack marginBottom={2}>
                <Divider />
            </Stack>
            {currentMerchantLimitData && (<>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid key={1} padding={3} sx={{ flex: 2 }}>

                        <Stack marginBottom={2} spacing={2}
                            direction={isDesktop ? "row" : "column"}
                            width={isDesktop ? "100%" : "auto"}>
                            <StatCard key={1} interval="Bu Ay" trend={currentMerchantLimitData?.usedLimitPercentage} title="Kullanılan Limit" value={formatDecimal(currentMerchantLimitData?.usedLimit)} />
                            <StatCard key={1} interval="Bu Ay" trendColorReversed={true} trend={currentMerchantLimitData?.remainingPercentage} title="Kalan Limit" value={formatDecimal((currentMerchantLimitData?.totalLimit) - currentMerchantLimitData?.usedLimit)} />
                        </Stack>
                        <Stack marginBottom={2} spacing={2}
                            direction={isDesktop ? "row" : "column"}
                            width={isDesktop ? "100%" : "auto"}>
                            <StatCard key={1} interval="Bu Ay" isBlury={(currentMerchantLimitData?.isAutomaticLimitIncreaseActive != true)} blurTooltip="İşyeri için otomatik limit artışı kapalı olduğundan, `Ekstra Limit` alanı kullanılamaz." title="Extra Limit" value={currentMerchantLimitData?.extraLimit} />
                            <StatCard key={1} interval="Bu Ay" trend={null} title="Limit Aşım Sayısı" value={currentMerchantLimitData?.limitExcessCount} />
                        </Stack>
                        <Stack spacing={2}>
                            <StatCard key={1} interval="Bu Ay" title="Tanımlanan Limit" value={formatDecimal(currentMerchantLimitData?.limit)} child={
                                <>
                                    <FormControl sx={{ marginTop: 2 }}>
                                        <InputControl
                                            id={"newLimit"}
                                            control={control}
                                            numeric={true}
                                            label="Yeni Limit"
                                            sx={{ width: '100%', marginBottom: '10px' }}
                                        />
                                    </FormControl>
                                    <Stack right={true} sx={{ marginTop: 2, float: 'right' }}>
                                        <Button
                                            sx={{ mb: 3, color: '#fff', backgroundColor: 'rgb(82, 188, 82)', ":hover": { backgroundColor: 'rgb(82, 188, 82)' }, float: 'right' }}
                                            size="medium"
                                            variant="contained"
                                            text="Güncelle"
                                            onClick={() => handleLimitUpdate()}
                                        />
                                    </Stack>
                                </>} />
                        </Stack>

                    </Grid>
                    <Grid key={2} padding={3} sx={{ flex: 1 }}>
                        <Card variant="outlined" sx={{ height: '485px', overflow: 'auto' }}>
                            <CardContent>
                                {BasicTimeline(currentMerchantLimitData?.histories)}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </>)}
            {currentMerchantTableData.isActive && (<Table
                isMasterDetailActive={false}
                isRowExpandable={false}
                masterDetailContent={MerchantLimitHistoryMaster}
                columnVisibilityConfigKey="merchantFilterListVisibilityKey"
                filterKey="merchantFilterListKey"
                hasActiveFilters={hasActiveFilters}
                handleFilterChange={handleFilterChange}
                paginationModel={paginationModel}
                onPaginationModelChange={handleChangePagination}
                paginationMode="server"
                rowCount={currentMerchantTableData?.data?.totalItems || 0}
                isRowSelectable={() => false}
                rows={currentMerchantTableData?.data?.result || []}
                customLabelDisplayedRows={true}
                autoHeight={false}
                columns={columns}
                exportFileName="İşyeri Limiti"
                onSave={null}
                extraToolbarButton={<></>}
                getRowClassName={(params, index) => {
                    console.log(params);
                    if ((params.row.status === 'VOID' && params.row.txnType.toUpperCase() === 'AUTH') ||
                        (params.row.status === 'VOID' && params.row.txnType.toUpperCase() === 'PREAUTH')) {
                        return 'blocked-row';
                    } else if ((params.row.status === 'SUCCESS' && params.row.txnType.toUpperCase() === 'REFUND')) {
                        return 'pasive-row';
                    } else if (params.row.status === 'Unmatched') {
                        return 'unmatched-row';
                    } else {
                        return '';
                    }
                }}
            />)}
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
            <Table
                isMasterDetailActive={true}
                isRowExpandable={true}
                masterDetailContent={MerchantLimitHistoryMaster}
                columnVisibilityConfigKey="merchantFilterListVisibilityKey"
                filterKey="merchantFilterListKey"
                hasActiveFilters={hasActiveFilters}
                handleFilterChange={handleFilterChange}
                paginationModel={paginationModel}
                onPaginationModelChange={handleChangePagination}
                paginationMode="server"
                rowCount={tableData?.totalItems || 0}
                isRowSelectable={() => false}
                rows={tableData?.result || []}
                customLabelDisplayedRows={true}
                autoHeight={false}
                columns={columns}
                exportFileName="İşyeri Limiti"
                onSave={null}
                extraToolbarButton={<></>}
                getRowClassName={(params, index) => {
                    console.log(params);
                    if ((params.row.status === 'VOID' && params.row.txnType.toUpperCase() === 'AUTH') ||
                        (params.row.status === 'VOID' && params.row.txnType.toUpperCase() === 'PREAUTH')) {
                        return 'blocked-row';
                    } else if ((params.row.status === 'SUCCESS' && params.row.txnType.toUpperCase() === 'REFUND')) {
                        return 'pasive-row';
                    } else if (params.row.status === 'Unmatched') {
                        return 'unmatched-row';
                    } else {
                        return '';
                    }
                }}
            />
        </CustomTabPanel>
    </>);
}